import type { PropsWithChildren } from 'react';
import { cn } from '../../utils/cn';
import { cva, type VariantProps } from 'class-variance-authority';

const variants = cva( '', {
  variants: {
    variant: {
      'dark': '',
      'light': ''
    }
  }
} )

type BlogFeaturedProps = PropsWithChildren<{
  className?: string;
}> & VariantProps<typeof variants>;

export const BlogFeatured = ( { className, children, variant = 'dark' }: BlogFeaturedProps ) => {

  return (
    <div
      className={ cn( 'relative rounded-[10px] overflow-hidden group', variants( { variant } ), className ) }
      data-variant={ variant }
    >
      { children }
    </div>
  )
}
BlogFeatured.displayName = 'BlogFeatured';
